// THESE ARE WORDINGS AND SOME OPTIONS WE CAN CUSTOMISE
// please note that we must keep the double quotes. it will break if the double quotes missing.

const ERROR_TEXT = "Invalid input. Choose one of the available dates from the calendar";


// THE BELOW IS THE CODE OF THE DATEPICKER
const moment = window.moment;
const timetableIconHTML = () => `
  <svg role="button" class="timetable-icon" width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_120_551)">
    <g clip-path="url(#clip1_120_551)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99524 3.73261C10.0112 4.21374 10.0218 4.8729 10.0286 5.80886C10.0339 6.53729 10.0324 7.16925 10.0245 7.45718C10.0218 7.60216 10.0183 7.70797 10.0147 7.77725C10.0121 7.81817 10.0097 7.84799 10.0062 7.87342C9.99849 7.93071 9.98284 7.98186 9.96099 8.02659L9.96069 8.05114C9.95922 8.23003 9.95686 8.444 9.95449 8.58694V8.59454C9.94829 8.76232 9.9418 8.9076 9.93471 9.02598L9.93406 9.04669C9.93226 9.10375 9.93065 9.15489 9.9288 9.20137C9.99406 9.33232 9.98963 9.48607 9.91493 9.61849C9.90223 9.64129 9.88628 9.66496 9.86709 9.68952L9.80862 9.755C9.80242 9.76084 9.79593 9.76669 9.78914 9.77253L9.77378 9.7851C9.76256 9.79387 9.75104 9.80176 9.73953 9.80966L9.6598 9.85233L9.6099 9.87133C9.57529 9.88266 9.54816 9.88877 9.52529 9.89393L9.52309 9.89443C9.49946 9.8991 9.47673 9.90319 9.45163 9.90699C9.28598 9.93243 9.02229 9.95026 8.62041 9.96458C7.66813 9.99469 6.54429 9.99936 5.67114 9.99995H5.67084C5.18835 9.99966 4.61905 9.99849 4.05418 9.99264L4.03853 9.99235C3.90831 9.99059 3.77366 9.98855 3.63842 9.98446L3.44442 9.9789L3.24688 9.97773C3.10101 9.97686 2.9572 9.9751 2.80927 9.96458C2.72098 9.95786 2.64214 9.9485 2.56714 9.93652C2.51783 9.92863 2.47737 9.92103 2.43898 9.91226C2.39971 9.90436 2.33357 9.88858 2.26034 9.85935C2.18504 9.82895 2.12156 9.79241 2.06339 9.74652C1.98012 9.68133 1.90866 9.5954 1.85787 9.49806C1.81417 9.4168 1.78287 9.32297 1.76515 9.22007C1.75423 9.15723 1.74803 9.09292 1.74655 9.01868C1.74534 8.97737 1.7465 8.93743 1.74745 8.90475C1.74766 8.89742 1.74786 8.89046 1.74803 8.88392L1.75688 8.56297C1.75954 8.42705 1.76072 8.28908 1.76043 8.15345L1.75954 7.72814L1.76279 6.02283L1.77106 4.10793C1.77106 3.98662 1.78346 3.86765 1.80826 3.75716C1.83691 3.62621 1.88651 3.49906 1.95147 3.39119C2.01378 3.28626 2.09351 3.19301 2.1877 3.11526C2.37225 2.96414 2.55592 2.9086 2.67816 2.88024C2.8013 2.85277 2.92797 2.83961 3.06941 2.83961H3.08624C3.13152 2.84 3.1768 2.84013 3.22207 2.84026C3.24471 2.84033 3.26735 2.84039 3.28999 2.84049L3.28703 2.68878C3.24688 1.84811 3.61096 1.71423 3.88114 1.71423C4.40792 1.71423 4.47584 1.75428 4.47584 2.52918V2.83727L4.49592 2.83705C4.72668 2.83449 4.95814 2.83193 5.18569 2.82909C5.54653 2.82441 5.90884 2.82003 6.27204 2.8174C6.33165 2.8172 6.39124 2.81694 6.45078 2.81668C6.56936 2.81616 6.68776 2.81564 6.80591 2.81564C7.01674 2.81564 7.20778 2.81681 7.38554 2.81944L7.38318 2.68878C7.34332 1.84811 7.7074 1.71423 7.97729 1.71423C8.50407 1.71423 8.57198 1.75428 8.57198 2.52918V2.86504C8.5819 2.86575 8.59178 2.86644 8.60162 2.86714C8.64481 2.87018 8.68728 2.87316 8.72937 2.87674L8.91894 2.89281C8.94491 2.89446 8.97107 2.89535 8.99743 2.89625C9.00374 2.89646 9.01005 2.89668 9.01638 2.8969L9.02298 2.89717C9.05039 2.89825 9.07827 2.89935 9.10615 2.9007C9.18292 2.90421 9.27416 2.91094 9.37397 2.93052C9.43244 2.94221 9.4847 2.95595 9.5349 2.9729L9.58155 2.99015C9.60577 2.99921 9.62821 3.00857 9.65065 3.01938C9.68254 3.03429 9.71354 3.05007 9.74484 3.06615L9.96335 3.18073L9.98048 3.44323C9.98461 3.50227 9.98845 3.56132 9.99111 3.61949L9.99524 3.73261ZM2.9262 4.44232H4.25172V5.66708C3.60948 5.68491 3.03988 5.71093 2.64952 5.74542L2.65543 4.42595C2.73781 4.43618 2.82787 4.44232 2.9262 4.44232ZM6.78405 4.44232H5.05813C5.08057 4.80741 5.0974 5.21927 5.10981 5.6475C5.66818 5.63726 6.24487 5.632 6.78405 5.63113V4.44232ZM2.64804 6.27391C2.73249 6.28092 2.82492 6.28443 2.9262 6.28443H4.25172V7.41595C3.60712 7.43232 3.03604 7.45512 2.64568 7.48581L2.64804 6.27391ZM9.09788 6.28443H7.65927C7.66517 6.66238 7.66724 7.03653 7.66665 7.38643C8.34343 7.39081 8.87465 7.40221 9.10615 7.41887C9.10821 7.10084 9.1094 6.77726 9.10969 6.45017V6.44374H9.14601L9.14571 6.36264L9.14542 6.28151C9.13874 6.28176 9.13195 6.28233 9.12515 6.2829C9.11601 6.28366 9.10685 6.28443 9.09788 6.28443ZM4.05034 9.11571L4.00651 9.11511C3.8939 9.11359 3.77873 9.11203 3.66795 9.1084L3.56726 9.1049L3.2519 9.1011C3.11666 9.10022 2.9953 9.09905 2.8763 9.09028C2.8137 9.08531 2.75878 9.07917 2.70917 9.07128C2.68555 9.06748 2.66192 9.06339 2.63594 9.05784C2.63387 9.04088 2.6324 9.02188 2.6321 8.99762C2.63124 8.96937 2.63232 8.94004 2.63319 8.9162L2.63328 8.91373L2.64244 8.58284C2.64509 8.43815 2.64627 8.29375 2.64627 8.15198L2.64598 7.95204C2.73072 7.95847 2.82374 7.96198 2.9262 7.96198H4.25172V9.11776L4.06481 9.116L4.05034 9.11571ZM5.09918 9.12244C5.2979 9.12303 5.49161 9.12332 5.67085 9.12332C6.0119 9.12303 6.39192 9.12215 6.78406 9.11923V7.96199H5.13225C5.12753 8.44897 5.11631 8.8582 5.09918 9.12244ZM9.04975 8.99354L9.05004 8.97921C9.05713 8.86814 9.06363 8.72988 9.06865 8.56823C9.07096 8.43925 9.07291 8.25516 9.07463 8.09184L9.07464 8.09171L9.07603 7.96199H7.66281C7.65602 8.47411 7.64185 8.88655 7.62147 9.10987C7.95337 9.1052 8.28172 9.09789 8.59029 9.08824C8.78783 9.08152 8.93577 9.07392 9.04709 9.06661C9.04768 9.04469 9.04857 9.02043 9.04975 8.99354ZM7.64569 5.63318C8.37001 5.63844 8.93193 5.65247 9.14217 5.67323C9.13804 5.18829 9.13302 4.78111 9.12711 4.43882C9.12317 4.43917 9.11913 4.43982 9.11511 4.44045C9.1092 4.44139 9.10333 4.44233 9.09788 4.44233H7.59903C7.61911 4.80829 7.63476 5.2146 7.64569 5.63318ZM5.13461 7.39841C5.13461 7.0415 5.13136 6.66384 5.12457 6.28443H6.78405V7.38467C6.25255 7.38525 5.68531 7.38993 5.13461 7.39841Z" fill="#909090"/>
    <mask id="mask0_120_551" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="1" width="10" height="9">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99524 3.73261C10.0112 4.21374 10.0218 4.8729 10.0286 5.80886C10.0339 6.53729 10.0324 7.16925 10.0245 7.45718C10.0218 7.60216 10.0183 7.70797 10.0147 7.77725C10.0121 7.81817 10.0097 7.84799 10.0062 7.87342C9.99849 7.93071 9.98284 7.98186 9.96099 8.02659L9.96069 8.05114C9.95922 8.23003 9.95686 8.444 9.95449 8.58694V8.59454C9.94829 8.76232 9.9418 8.9076 9.93471 9.02598L9.93406 9.04669C9.93226 9.10375 9.93065 9.15489 9.9288 9.20137C9.99406 9.33232 9.98963 9.48607 9.91493 9.61849C9.90223 9.64129 9.88628 9.66496 9.86709 9.68952L9.80862 9.755C9.80242 9.76084 9.79593 9.76669 9.78914 9.77253L9.77378 9.7851C9.76256 9.79387 9.75104 9.80176 9.73953 9.80966L9.6598 9.85233L9.6099 9.87133C9.57529 9.88266 9.54816 9.88877 9.52529 9.89393L9.52309 9.89443C9.49946 9.8991 9.47673 9.90319 9.45163 9.90699C9.28598 9.93243 9.02229 9.95026 8.62041 9.96458C7.66813 9.99469 6.54429 9.99936 5.67114 9.99995H5.67084C5.18835 9.99966 4.61905 9.99849 4.05418 9.99264L4.03853 9.99235C3.90831 9.99059 3.77366 9.98855 3.63842 9.98446L3.44442 9.9789L3.24688 9.97773C3.10101 9.97686 2.9572 9.9751 2.80927 9.96458C2.72098 9.95786 2.64214 9.9485 2.56714 9.93652C2.51783 9.92863 2.47737 9.92103 2.43898 9.91226C2.39971 9.90436 2.33357 9.88858 2.26034 9.85935C2.18504 9.82895 2.12156 9.79241 2.06339 9.74652C1.98012 9.68133 1.90866 9.5954 1.85787 9.49806C1.81417 9.4168 1.78287 9.32297 1.76515 9.22007C1.75423 9.15723 1.74803 9.09292 1.74655 9.01868C1.74534 8.97737 1.7465 8.93743 1.74745 8.90475C1.74766 8.89742 1.74786 8.89046 1.74803 8.88392L1.75688 8.56297C1.75954 8.42705 1.76072 8.28908 1.76043 8.15345L1.75954 7.72814L1.76279 6.02283L1.77106 4.10793C1.77106 3.98662 1.78346 3.86765 1.80826 3.75716C1.83691 3.62621 1.88651 3.49906 1.95147 3.39119C2.01378 3.28626 2.09351 3.19301 2.1877 3.11526C2.37225 2.96414 2.55592 2.9086 2.67816 2.88024C2.8013 2.85277 2.92797 2.83961 3.06941 2.83961H3.08624C3.13152 2.84 3.1768 2.84013 3.22207 2.84026C3.24471 2.84033 3.26735 2.84039 3.28999 2.84049L3.28703 2.68878C3.24688 1.84811 3.61096 1.71423 3.88114 1.71423C4.40792 1.71423 4.47584 1.75428 4.47584 2.52918V2.83727L4.49592 2.83705C4.72668 2.83449 4.95814 2.83193 5.18569 2.82909C5.54653 2.82441 5.90884 2.82003 6.27204 2.8174C6.33165 2.8172 6.39124 2.81694 6.45078 2.81668C6.56936 2.81616 6.68776 2.81564 6.80591 2.81564C7.01674 2.81564 7.20778 2.81681 7.38554 2.81944L7.38318 2.68878C7.34332 1.84811 7.7074 1.71423 7.97729 1.71423C8.50407 1.71423 8.57198 1.75428 8.57198 2.52918V2.86504C8.5819 2.86575 8.59178 2.86644 8.60162 2.86714C8.64481 2.87018 8.68728 2.87316 8.72937 2.87674L8.91894 2.89281C8.94491 2.89446 8.97107 2.89535 8.99743 2.89625C9.00374 2.89646 9.01005 2.89668 9.01638 2.8969L9.02298 2.89717C9.05039 2.89825 9.07827 2.89935 9.10615 2.9007C9.18292 2.90421 9.27416 2.91094 9.37397 2.93052C9.43244 2.94221 9.4847 2.95595 9.5349 2.9729L9.58155 2.99015C9.60577 2.99921 9.62821 3.00857 9.65065 3.01938C9.68254 3.03429 9.71354 3.05007 9.74484 3.06615L9.96335 3.18073L9.98048 3.44323C9.98461 3.50227 9.98845 3.56132 9.99111 3.61949L9.99524 3.73261ZM2.9262 4.44232H4.25172V5.66708C3.60948 5.68491 3.03988 5.71093 2.64952 5.74542L2.65543 4.42595C2.73781 4.43618 2.82787 4.44232 2.9262 4.44232ZM6.78405 4.44232H5.05813C5.08057 4.80741 5.0974 5.21927 5.10981 5.6475C5.66818 5.63726 6.24487 5.632 6.78405 5.63113V4.44232ZM2.64804 6.27391C2.73249 6.28092 2.82492 6.28443 2.9262 6.28443H4.25172V7.41595C3.60712 7.43232 3.03604 7.45512 2.64568 7.48581L2.64804 6.27391ZM9.09788 6.28443H7.65927C7.66517 6.66238 7.66724 7.03653 7.66665 7.38643C8.34343 7.39081 8.87465 7.40221 9.10615 7.41887C9.10821 7.10084 9.1094 6.77726 9.10969 6.45017V6.44374H9.14601L9.14571 6.36264L9.14542 6.28151C9.13874 6.28176 9.13195 6.28233 9.12515 6.2829C9.11601 6.28366 9.10685 6.28443 9.09788 6.28443ZM4.05034 9.11571L4.00651 9.11511C3.8939 9.11359 3.77873 9.11203 3.66795 9.1084L3.56726 9.1049L3.2519 9.1011C3.11666 9.10022 2.9953 9.09905 2.8763 9.09028C2.8137 9.08531 2.75878 9.07917 2.70917 9.07128C2.68555 9.06748 2.66192 9.06339 2.63594 9.05784C2.63387 9.04088 2.6324 9.02188 2.6321 8.99762C2.63124 8.96937 2.63232 8.94004 2.63319 8.9162L2.63328 8.91373L2.64244 8.58284C2.64509 8.43815 2.64627 8.29375 2.64627 8.15198L2.64598 7.95204C2.73072 7.95847 2.82374 7.96198 2.9262 7.96198H4.25172V9.11776L4.06481 9.116L4.05034 9.11571ZM5.09918 9.12244C5.2979 9.12303 5.49161 9.12332 5.67085 9.12332C6.0119 9.12303 6.39192 9.12215 6.78406 9.11923V7.96199H5.13225C5.12753 8.44897 5.11631 8.8582 5.09918 9.12244ZM9.04975 8.99354L9.05004 8.97921C9.05713 8.86814 9.06363 8.72988 9.06865 8.56823C9.07096 8.43925 9.07291 8.25516 9.07463 8.09184L9.07464 8.09171L9.07603 7.96199H7.66281C7.65602 8.47411 7.64185 8.88655 7.62147 9.10987C7.95337 9.1052 8.28172 9.09789 8.59029 9.08824C8.78783 9.08152 8.93577 9.07392 9.04709 9.06661C9.04768 9.04469 9.04857 9.02043 9.04975 8.99354ZM7.64569 5.63318C8.37001 5.63844 8.93193 5.65247 9.14217 5.67323C9.13804 5.18829 9.13302 4.78111 9.12711 4.43882C9.12317 4.43917 9.11913 4.43982 9.11511 4.44045C9.1092 4.44139 9.10333 4.44233 9.09788 4.44233H7.59903C7.61911 4.80829 7.63476 5.2146 7.64569 5.63318ZM5.13461 7.39841C5.13461 7.0415 5.13136 6.66384 5.12457 6.28443H6.78405V7.38467C6.25255 7.38525 5.68531 7.38993 5.13461 7.39841Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_120_551)">
    <rect x="0.365082" y="0.333252" width="11.0476" height="11.0476" rx="1.84127" fill="#008A26"/>
    </g>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_120_551">
    <rect width="11.0476" height="11.0476" fill="white" transform="translate(0.365082 0.333313)"/>
    </clipPath>
    <clipPath id="clip1_120_551">
    <rect width="8.28571" height="8.28571" fill="white" transform="translate(1.74603 1.71423)"/>
    </clipPath>
    </defs>
  </svg>
`;

const iconArrowDown = ({ isUp }) => `
  <svg role="button" style="margin-left: 4px; transform: ${isUp ? 'rotate(180deg' : 'none'}" width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.13504 8C5.2872 8 4.82405 8.98886 5.36682 9.64018L8.23178 13.0781C8.63157 13.5579 9.36843 13.5579 9.76822 13.0781L12.6332 9.64018C13.176 8.98886 12.7128 8 11.865 8L6.13504 8Z" fill="#454545"/>
    <mask id="mask0_33_839" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="5" y="8" width="8" height="6">
    <path d="M6.13504 8C5.2872 8 4.82405 8.98886 5.36682 9.64018L8.23178 13.0781C8.63157 13.5579 9.36843 13.5579 9.76822 13.0781L12.6332 9.64018C13.176 8.98886 12.7128 8 11.865 8L6.13504 8Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_33_839)">
    <rect y="2" width="18.5625" height="18" rx="4" fill="black"/>
    </g>
  </svg>
`;

const iconArrowRight = (p = {}) => `
  <svg role="button" class="next-month${p.isDisabled ? ' disabled' : ''}" style="margin: 4px; margin-left: 8px; cursor: pointer;" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.1225 2.7075C6.73176 2.31676 6.09824 2.31676 5.7075 2.7075C5.31676 3.09824 5.31676 3.73176 5.7075 4.1225L9.27933 7.69433C9.44815 7.86315 9.44815 8.13685 9.27933 8.30567L5.7075 11.8775C5.31676 12.2682 5.31676 12.9018 5.7075 13.2925C6.09824 13.6832 6.73176 13.6832 7.1225 13.2925L11.665 8.75C12.0792 8.33579 12.0792 7.66421 11.665 7.25L7.1225 2.7075Z" fill="black"/>
    <mask id="mask0_33_842" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="5" y="2" width="7" height="12">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.1225 2.7075C6.73176 2.31676 6.09824 2.31676 5.7075 2.7075C5.31676 3.09824 5.31676 3.73176 5.7075 4.1225L9.27933 7.69433C9.44815 7.86315 9.44815 8.13685 9.27933 8.30567L5.7075 11.8775C5.31676 12.2682 5.31676 12.9018 5.7075 13.2925C6.09824 13.6832 6.73176 13.6832 7.1225 13.2925L11.665 8.75C12.0792 8.33579 12.0792 7.66421 11.665 7.25L7.1225 2.7075Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_33_842)">
    <rect x="-8" y="-7" width="33" height="32" rx="4" fill="black"/>
    </g>
  </svg>
`;

const iconArrowLeft = (p = {}) => `
  <svg class="prev-month${p.isDisabled ? ' disabled' : ''}" style="margin: 4px; cursor: pointer;" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29249 2.7075C9.68323 2.31676 10.3168 2.31676 10.7075 2.7075C11.0982 3.09824 11.0982 3.73176 10.7075 4.1225L7.13566 7.69433C6.96684 7.86315 6.96685 8.13685 7.13566 8.30567L10.7075 11.8775C11.0982 12.2682 11.0982 12.9018 10.7075 13.2925C10.3168 13.6832 9.68323 13.6832 9.29249 13.2925L4.74999 8.75C4.33578 8.33579 4.33578 7.66421 4.74999 7.25L9.29249 2.7075Z" fill="black"/>
    <mask id="mask0_129_181" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="4" y="2" width="8" height="12">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29249 2.7075C9.68323 2.31676 10.3168 2.31676 10.7075 2.7075C11.0982 3.09824 11.0982 3.73176 10.7075 4.1225L7.13566 7.69433C6.96684 7.86315 6.96685 8.13685 7.13566 8.30567L10.7075 11.8775C11.0982 12.2682 11.0982 12.9018 10.7075 13.2925C10.3168 13.6832 9.68323 13.6832 9.29249 13.2925L4.74999 8.75C4.33578 8.33579 4.33578 7.66421 4.74999 7.25L9.29249 2.7075Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_129_181)">
    <rect x="-8" y="-7" width="33" height="32" rx="4" fill="black"/>
    </g>
  </svg>
`;

const iconInfo = () => `
  <svg width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_129_83)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.38092 4.20637C0.38092 2.24281 1.97291 0.650818 3.93648 0.650818C5.90024 0.650818 7.49203 2.24281 7.49203 4.20637C7.49203 6.17038 5.90026 7.76193 3.93648 7.76193C1.97291 7.76193 0.38092 6.17016 0.38092 4.20637ZM1.04757 4.20635C1.04757 5.80189 2.3409 7.09523 3.93645 7.09523C5.532 7.09523 6.82533 5.80189 6.82533 4.20635C6.82533 2.6108 5.532 1.31747 3.93645 1.31747C2.3409 1.31747 1.04757 2.6108 1.04757 4.20635ZM3.93669 2.21014C3.68204 2.21014 3.48935 2.34304 3.48935 2.5577V4.52658C3.48935 4.74147 3.68201 4.87392 3.93669 4.87392C4.18514 4.87392 4.38404 4.73592 4.38404 4.52658V2.5577C4.38401 2.34814 4.18514 2.21014 3.93669 2.21014ZM3.49289 5.76146C3.49289 5.51659 3.69201 5.31747 3.93667 5.31747C4.18134 5.31747 4.38021 5.51657 4.38024 5.76146C4.38024 6.0059 4.18134 6.20502 3.93667 6.20502C3.69201 6.20502 3.49289 6.0059 3.49289 5.76146Z" fill="#DD0F0F"/>
    <mask id="mask0_129_83" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="8" height="8">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.38092 4.20637C0.38092 2.24281 1.97291 0.650818 3.93648 0.650818C5.90024 0.650818 7.49203 2.24281 7.49203 4.20637C7.49203 6.17038 5.90026 7.76193 3.93648 7.76193C1.97291 7.76193 0.38092 6.17016 0.38092 4.20637ZM1.04757 4.20635C1.04757 5.80189 2.3409 7.09523 3.93645 7.09523C5.532 7.09523 6.82533 5.80189 6.82533 4.20635C6.82533 2.6108 5.532 1.31747 3.93645 1.31747C2.3409 1.31747 1.04757 2.6108 1.04757 4.20635ZM3.93669 2.21014C3.68204 2.21014 3.48935 2.34304 3.48935 2.5577V4.52658C3.48935 4.74147 3.68201 4.87392 3.93669 4.87392C4.18514 4.87392 4.38404 4.73592 4.38404 4.52658V2.5577C4.38401 2.34814 4.18514 2.21014 3.93669 2.21014ZM3.49289 5.76146C3.49289 5.51659 3.69201 5.31747 3.93667 5.31747C4.18134 5.31747 4.38021 5.51657 4.38024 5.76146C4.38024 6.0059 4.18134 6.20502 3.93667 6.20502C3.69201 6.20502 3.49289 6.0059 3.49289 5.76146Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_129_83)">
    <rect x="0.38092" y="0.650818" width="7.33333" height="7.11111" rx="2.03175" fill="#DD0F0F"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_129_83">
    <rect width="7.11111" height="7.11111" fill="white" transform="translate(0.38092 0.650818)"/>
    </clipPath>
    </defs>
  </svg>
`;

const styles = (style, isInvalid) => `
<style>
  :host {
    position: relative;
    width: auto;
    display: inline-block;
    font-family: Helvetica,sans-serif;
    ${isInvalid ? 'margin-bottom: 40px;' : ''}
  }
  input {
    height: 40px;
    width: 300px;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    padding: 5px;
    padding-left: 10px;
    padding-right: 30px;
    border-radius: 4px;
    border: 0.507936px solid #B5B5B5;
    color: #767676;
    outline: none;
    user-select: text;
    -webkit-user-select: text;
    ${style}
  }
  input.invalid {
    border-color: #EC1616;
    border-width: 1px;
  }
  .timetable-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .drop-down {
    position: absolute;
    top: 52px;
    left: 0px;
    right: 0px;
    background-color: white;
    border-radius: 4px;
    border: 0.507936px solid #B5B5B5;
    padding: 10px;
    height: 300px;
    padding: 30px 15px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    user-select: none;
    z-index: 1;
  }
  .drop-down:before {
    position: absolute;
    top: -7px;
    left: 12px;
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    border-top: 0.507936px solid #B5B5B5;
    border-left: 0.507936px solid #B5B5B5;
    transform: rotate(45deg);
    background-color: white;
  }
  .drop-down:after {
    position: absolute;
    content: '';
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
    width: 3px;
    background-color: #01D664;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .row {
    display: flex;
    align-items: center;
  }
  .space-between {
    justify-content: space-between;
  }
  .wrap {
    flex-wrap: wrap;
  }
  .displaying-month {
    margin: 0px;
    color: #008A26;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    line-height: 20px;
    font-family: Cera Pro;
    font-weight: 700;
    height: 32px;
  }
  .next-month,.prev-month {
    user-select: none;
  }
  .next-month.disabled,
  .prev-month.disabled {
    opacity: 0.5;
  }

  .weekday,
  .weekday-title-column {
    font-weight: 400;
    color: #6B6B6B;
    font-size: 16px;
    line-height: 18px;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-radius: 18px;
  }
  .weekday {
    color: #B5B5B5;
    margin-bottom: 4px;
  }
  .weekday.selected,
  .weekday.selectable:hover {
    cursor: pointer;
    background-color: black;
    color: white;
    font-weight: 700;
  }
  .weekday.selectable {
    background-color: #AAEFC0;
    color: black;
  }
  .weekday.selected {
    background-color: black;
    color: white;
  }
  .weekday.today:after {
    position: absolute;
    content: '';
    font-size: 20px;
    display: block;
    bottom: 4px;
    left: 50%;
    width: 4px;
    height: 4px;
    background-color: black;
    border-radius: 2px;
    transform: translateX(-50%);
  }
  .weekday.selectable:hover.today:after {
    background-color: white;
  }
  .error-row {
    position: absolute;
    top: 52px;
    left: 0px;
    right: 0px;
    height: 30px;
    display: flex;
    align-items: flex-start;
  }
  #the-overlay-container {
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
    background-color: rgba(0,0,0,0.05);
    z-index: 1000;
  }
</style>
`;

const twoDigits = num => num >= 10 ? num : '0' + num;

const computeDisplayDaysInMonth = (month, year) => {
  const firstDayOfMonth = moment(`01/${twoDigits(month+1)}/${year}`, 'DD/MM/YYYY');
  const firstDisplayMonday = firstDayOfMonth.clone().startOf('isoWeek');

  const lastDayOfMonth = firstDayOfMonth.endOf('month');
  const lastDisplaySunday = lastDayOfMonth.clone().endOf('isoWeek');
  const list = [];
  for (let i = firstDisplayMonday.clone(); i.isBefore(lastDisplaySunday); i = i.add(1, 'days')) {
    list.push({
      obj: i.clone(),
      display: i.format('DD/MM/YYYY'),
      weekday: i.format('dddd'),
      date: i.format('D'),
      isToday: i.isSame(moment(), 'day'),
    });
  }
  // console.log('list', list);
  return list;
};

const setOnClick = (el, func) => {
  if (!el) return;
  const iOS = () => {
    if (typeof window === 'undefined') return false;
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  if (iOS()) {
    el.ontouchstart = func;
  } else {
    el.onclick = func;
  }
};

class MacmillanDatePicker extends HTMLElement {
  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: "open" });
    const today = new Date();
    this._state = {
      showDropdown: false,
      today: {
        obj: today,
        dateInMonth: today.getDate(),
        dayInWeek: today.getDay(),
      },
      displayingMonth: moment(today).format('MMMM YYYY'),
      selectedYear: today.getFullYear(),
      selectedMonth: today.getMonth(),
      displayingDays: computeDisplayDaysInMonth(
        today.getMonth(),
        today.getFullYear()
      ),
      canPrevMonth: false,
      canNextMonth: true,
      showMonthsInstead: false,
    }
  }

  inputEl;
  _onchange;

  static get observedAttributes() {
    return ['value', 'availabledays'];
  }
  get value() {
    return this.getAttribute('value');
  }
  set value(val) {
    this.setAttribute('value', val);
  }
  get state() {
    return this._state;
  }
  set state(val) {
    this._state = val;
  }
  setState(val) {
    this._state = {
      ...this._state,
      ...val,
    };
    this.renderHTML();
  }
  set onchange(val) {
    this._onchange = val;
    if (!!this.inputEl) {
      this.inputEl.onchange = val;
    }
  }
  set oninput(val) {
    if (!!this.inputEl) {
      this.inputEl.oninput = val;
    }
  }
  get availabledays() {
    return this.getAttribute('availabledays');
  }
  set availabledays(val) {
    this.setAttribute('availabledays', val);
  }

  get exceptdates() {
    return this.getAttribute('exceptdates');
  }
  set exceptdates(val) {
    this.setAttribute('exceptdates', val);
  }

  attributeChangedCallback(attrName, oldVal, newVal) {
    // console.log(attrName, oldVal, newVal);
    this.renderHTML();
  }

  connectedCallback() {
    this.renderHTML();
    document.addEventListener("click", (evt) => {
      let targetEl = evt.target; // clicked element      
      do {
        if(targetEl == this) {
          return;
        }
        // Go up the DOM
        targetEl = targetEl.parentNode;
      } while (targetEl);
      if (this.inputEl) {
        const obj = moment(this.inputEl.value, 'DD/MM/YYYY');
        if (!obj.isValid() || !this._isThisDayAvailable({ obj: obj })) {
          this.value = 'Invalid date';
        } else {
          this.value = this.inputEl.value;
        }
      }
      if (this.state.showDropdown) this.setState({ showDropdown: false });
    });
  }

  _isInRange2Months = (month, year) => {
    const obj = moment(`${twoDigits(month)}/${year}`, 'MM/YYYY');
    const diffDays = obj.diff(moment(), 'days')
    return diffDays > -30 && diffDays <= 60;
  }

  // a: DD/MM-DD/MM
  // b: DD/MM-DD/MM
  _getOverlapRange = (a, b) => {
    const aParts = a.split('-').map(v => v.trim());
    const bParts = b.split('-').map(v => v.trim());
    const aObj = {
      start: moment(aParts[0], 'DD/MM'),
      end: moment(aParts[1], 'DD/MM'),
    };
    const bObj = {
      start: moment(bParts[0], 'DD/MM'),
      end: moment(bParts[1], 'DD/MM'),
    };
    const higher = aObj.end.isAfter(bObj.end) ? aObj : bObj;
    const lower = aObj.end.isAfter(bObj.end) ? bObj : aObj;
    let start;
    let end = higher.end;
    if (higher.start.isAfter(lower.end)) {
      return 'No date';
    } else if(lower.start.isAfter(higher.start)) {
      start = lower.start;
    } else {
      start = higher.start;
    }
    return `${start.format('DD/MM')}-${end.format('DD/MM')}`;
  }

  _isThisDayAvailable = ({ obj }) => {
    // console.log('obj.hours()', obj.hours());
    console.log('this.availabledays', this.availabledays);
    if (!!this.exceptdates && this.exceptdates.includes(obj.format('DD/MM'))) return false;
    if (!!this.exceptdates && this.exceptdates.includes(obj.format('dddd'))) return false;
    if (this.availabledays === 'all') return true;
    if (this.availabledays === 'work-days-from-now') return obj.isAfter() && obj.format('dddd') !== 'Sunday';
    if (this.availabledays === 'work-days-from-1pm') return obj.hours() < 13 ? obj.clone().subtract(1, 'days').isAfter() && obj.format('dddd') !== 'Sunday' : obj.clone().subtract(2, 'days').isAfter() && obj.format('dddd') !== 'Sunday';
    if (this.availabledays === 'work-days-from-2pm') return obj.hours() < 14 ? obj.clone().subtract(1, 'days').isAfter() && obj.format('dddd') !== 'Sunday' : obj.clone().subtract(2, 'days').isAfter() && obj.format('dddd') !== 'Sunday';
    if (this.availabledays.includes(obj.format('DD/MM/YYYY'))) return true;
    if (this.availabledays.includes('Cut-off') && this.availabledays.includes('Number of days')) {
      const parts = this.availabledays.split(',').map(v => v.trim()).filter(Boolean);
      const cutoff = parts.find(v => v.includes('Cut-off')).split(':').map(v => v.trim())[1];
      const numberOfDays = parts.find(v => v.includes('Number of days')).split(':').map(v => v.trim())[1];
      

      // product specific tags: Available, Unavailable, Delivery
      
      const available = (() => {
        const filter = parts.filter(v => v.toLowerCase().startsWith('available') && v.includes(':'));
        const values = filter.map(item => item.split(':').map(v => v.trim())[1]).filter(Boolean);
        console.log('values', values);
        // there might be multiple available, check if it overlaps
        return values.length === 0 ? '' : (
          values.length === 1 ? values[0] : (
            values.reduce((a, b) => {
              if (a === 'No date' || b === 'No date') return 'No date';
              return this._getOverlapRange(a, b);
            })
          )
        );
      })();
      console.log('available', available);
      
      if (available === 'No date') return false;
      else if (available.includes('-')) {
        const parts = available.split('-').map(v => v.trim());
        // console.log('parts', parts);
        const start = moment(parts[0], 'DD/MM');
        const end = moment(parts[1], 'DD/MM');
        // console.log('start', start.format());
        // console.log('end', end.format());
        // console.log('obj.isAfter(end) || start.isAfter(obj)', obj.isAfter(end) || start.isAfter(obj));
        if (obj.isAfter(end) || start.isAfter(obj)) return false;
      }
      
      const unavailable = (() => {
        const filter = parts.filter(v => v.toLowerCase().startsWith('unavailable') && v.includes(':'));
        return filter.map(item => item.split(':').map(v => v.trim())[1]).filter(Boolean)
      })();
      console.log('unavailable', unavailable);
      for (let i=0; i<unavailable.length; i++) {
        const thisUnavailable = unavailable[i];
        if (obj.format('dddd') === thisUnavailable) return false;
        if (thisUnavailable.includes('-')) {
          const parts = thisUnavailable.split('-').map(v => v.trim());
          const start = moment(parts[0], 'DD/MM');
          const end = moment(parts[1], 'DD/MM');
          if (!start.isAfter(obj) && !obj.isAfter(end)) return false;
        }
      }

      const delivery = (() => {
        const filter = parts.filter(v => v.toLowerCase().includes('delivery') && v.includes(':'));
        const all = filter.map(item => item.split(':').map(v => v.trim())[1]).filter(Boolean);
        return all.length === 0 ? 0 : all.map(v => +v.replace('-days', '')).sort((a,b) => a > b ? -1 : 1)[0];
      })();
     
      // const delivery = 0;
      let numberOfCutOff = +moment(cutoff, ["h A"]).format("HH");
      if (numberOfCutOff < delivery) numberOfCutOff = delivery;
      console.log('numberOfDays', numberOfDays);
      console.log('numberOfCutOff', numberOfCutOff);
      
      return obj.hours() < numberOfCutOff ? obj.clone().subtract(numberOfDays, 'days').isAfter() : obj.clone().subtract(numberOfDays + 1, 'days').isAfter();
    }
    return false;
  }

  getEarliestAvailableDay = () => {
    for (let i=0; i<365; i++) {
      const obj = moment().add(i, 'days');
      obj.subtract(obj.hours(), 'hours');
      if (this._isThisDayAvailable({ obj: obj })) return obj;
    }
    return;
  }

  displayAMonth = (momentObj) => {
    this.setState({
      displayingMonth: momentObj.format('MMMM YYYY'),
      selectedYear: momentObj.toDate().getFullYear(),
      selectedMonth: momentObj.toDate().getMonth(),
      displayingDays: computeDisplayDaysInMonth(
        momentObj.toDate().getMonth(),
        momentObj.toDate().getFullYear()
      ),
      canPrevMonth: momentObj.isAfter(),
      canNextMonth: momentObj.isBefore() ? true : momentObj.diff(moment(), 'days') <= 30,
      showMonthsInstead: false,
    });
  }

  iOS() {
    if (typeof window === 'undefined') return false;
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }


  renderHTML() {
    const inlineStyle = this.getAttribute("style") || "";
    const state = this._state;
    const isInvalid = (() => {
      if (!this.value) return false;
      var regExp = /[a-zA-Z]/g;
      if (regExp.test(this.value)) return true;
      return !moment(this.value, 'DD/MM/YYYY').isValid();
    })();
    // console.log('state', state);
    const possibleMonthList = !state.showMonthsInstead ? [] : (
      new Date().getMonth() < 11 ? [
        new Date().getFullYear()
      ] : [
        new Date().getFullYear(),
        new Date().getFullYear() + 1,
      ]
    );
    this.shadow.innerHTML = `
        ${styles(inlineStyle, isInvalid)}
        <div id="the-input-container" style="position: relative;">
          <input class="${isInvalid ? 'invalid' : ''}" id="the-input" value="${this.value || ''}" />
          ${/* this.iOS() ? `<div id="the-overlay-container"></div>` : '' */ ''}
        </div>
        ${timetableIconHTML()}
        ${isInvalid ? `
          <div class="error-row">
            ${iconInfo()}
            <div style="flex: 1; margin-left: 8px; color: #DD0F0F; transform: translateY(-5px);">${ERROR_TEXT}</div>
          </div>
        ` : ``}
        ${state.showDropdown ? (`
          <div class="drop-down">
            <div class="row space-between">
              <h3 class="displaying-month">${state.showMonthsInstead ? 'Select a month' : state.displayingMonth} ${iconArrowDown({ isUp: state.showMonthsInstead })}</h3>
              ${state.showMonthsInstead ? `
                <div>
                  
                </div>
              ` : `
                <div>
                  ${iconArrowLeft({ isDisabled: !state.canPrevMonth })}
                  ${iconArrowRight({ isDisabled: !state.canNextMonth })}
                </div>
              `}
            </div>
            ${state.showMonthsInstead ? `
              ${possibleMonthList.map(year => {
                return `
                  <div class="weekday-title-column">${year}</div>
                  <div class="row wrap space-between" style="margin: 0px -5px 0px -5px;">
                    ${[1,2,3,4,5,6,7,8,9,10,11,12,'', ''].map(month => `
                      <div data-year="${year}" class="select-a-month weekday${
                        new Date().getMonth() === month - 1 ? ' today' : ''
                      }${
                        this._isInRange2Months(month, year) ? ' selectable' : ''
                      }">
                        ${month}
                      </div>
                    `).join('\n')}
                  </div>
                `;
              }).join('\n')}
            ` : `
              <div class="row space-between" style="margin: 10px -5px 0px -5px;">
                <div class="weekday-title-column">Mo</div>
                <div class="weekday-title-column">Tu</div>
                <div class="weekday-title-column">We</div>
                <div class="weekday-title-column">Th</div>
                <div class="weekday-title-column">Fr</div>
                <div class="weekday-title-column">Sa</div>
                <div class="weekday-title-column">Su</div>
              </div>
              <div class="row wrap space-between" style="margin: 10px -5px 0px -5px;">
                ${state.displayingDays.map(val => `
                  <div role="button" data-display="${val.display}" class="select-a-day weekday${
                    val.isToday ? ' today' : ''
                  }${
                    this._isThisDayAvailable(val) ? " selectable" : ""
                  }${
                    val.display === this.value ? " selected" : ""
                  }">
                    ${val.date}
                  </div>
                `).join('\n')}
              </div>
            `}
            
          </div>
        `) : ''}
      `;
    const timtableIconEl = this.shadowRoot.querySelector('.timetable-icon');
    this.inputEl = this.shadowRoot.querySelector('#the-input');
    // this.inputEl.onfocus = () => {
    //   this.setState({ showDropdown: !this.state.showDropdown });
    // };
    // const inputOverlay = this.shadowRoot.querySelector('#the-overlay-container');
    // console.log('inputOverlay', inputOverlay);
    // if (!!inputOverlay) {
    //     inputOverlay.onclick = (e) => {
    //       e.stopPropagation();
    //       this.setState({ showDropdown: !this.state.showDropdown });
    //     };
    // }
    // if (this.iOS()) {
    //   this.onclick = this.state.showDropdown ? null : () => {
    //     this.setState({ showDropdown: true });
    //   }
    // }
    this.inputEl.onblur = () => {
      this._isMouseDown = false;
    }
    this.inputEl.onmousedown = () => {
      if (!this.state.showDropdown) {
        this.setState({ showDropdown: true });
        setTimeout(() => {
          this.inputEl.focus();
          this.inputEl.value = '';
          this.inputEl.value = this.value;
        }, 300);
      }
    };
    this.inputEl.oninput = () => {
      // this.value = this.inputEl.value;
      // this.inputEl.focus();
      // this.inputEl.value = '';
      // this.inputEl.value = this.value;
    }
    if (this._onchange) {
      this.inputEl.onchange = this._onchange;
    }
    setOnClick(timtableIconEl, () => {
      this.setState({ showDropdown: !this.state.showDropdown });
    });
    const nextMonthIcon = this.shadowRoot.querySelector('.next-month');
    const prevtMonthIcon = this.shadowRoot.querySelector('.prev-month');
    if (nextMonthIcon) {
      // nextMonthIcon.onclick = () => {
      //   if (state.canNextMonth) {
      //     const currentDisplaying = moment(`${twoDigits(this.state.selectedMonth + 1)}/${this.state.selectedYear}`, 'MM/YYYY');
      //     const nextMonth = currentDisplaying.clone().add(1, 'months');
      //     this.displayAMonth(nextMonth);
      //   }
      // }
      setOnClick(nextMonthIcon, () => {
        if (state.canNextMonth) {
          const currentDisplaying = moment(`${twoDigits(this.state.selectedMonth + 1)}/${this.state.selectedYear}`, 'MM/YYYY');
          const nextMonth = currentDisplaying.clone().add(1, 'months');
          this.displayAMonth(nextMonth);
        }
      });
    }
    if (prevtMonthIcon) {
      setOnClick(prevtMonthIcon, () => {
        if (state.canPrevMonth) {
          const nextMonth = moment(`${twoDigits(this.state.selectedMonth + 1)}/${this.state.selectedYear}`, 'MM/YYYY').subtract(1, 'months');
          this.displayAMonth(nextMonth);
        }
      });
    }
    const displayingMonth = this.shadowRoot.querySelector('.displaying-month');
    if (displayingMonth) {
      setOnClick(displayingMonth, () => {
        this.setState({ showMonthsInstead: !this.state.showMonthsInstead });
      })
    }
    const selectableMonths = this.shadowRoot.querySelectorAll('.select-a-month.selectable');
    selectableMonths.forEach(el => {
      setOnClick(el, () => {
        const year = el.getAttribute('data-year');
        const clickedMonth = moment(`${twoDigits(el.innerHTML.trim())}/${year}`, 'MM/YYYY');
        this.displayAMonth(clickedMonth);
      });
    });
    const selectableDays = this.shadowRoot.querySelectorAll('.select-a-day.selectable');
    selectableDays.forEach(el => {
      setOnClick(el, (e) => {
        e.stopImmediatePropagation();
        this.value = el.getAttribute('data-display');
        this.inputEl.onchange && this.inputEl.onchange();
        setTimeout(() => {
          this.setState({ showDropdown: false });
        }, this.iOS() ? 600 : 0);
        
      });
    });
  }

}
customElements.define("macmillan-datepicker", MacmillanDatePicker);
